import { view } from '@yola/ws-sdk';
import { BREAKPOINT_READ_CASCADE, DESKTOP_BREAKPOINT } from '../constants/breakpoints';

const getEffectiveResponsiveAttribute = ({
  element,
  attr,
  breakpoint = null,
  skipOwnBreakpoint = false,
}) => {
  const cascade = BREAKPOINT_READ_CASCADE[breakpoint] || [DESKTOP_BREAKPOINT];
  const readOrder = skipOwnBreakpoint ? cascade.slice(1) : cascade;

  return readOrder.reduce(
    (found, breakpointInCascade) =>
      found || view.accessors.getResponsiveAttribute(element, attr, breakpointInCascade) || null,
    null
  );
};

export default getEffectiveResponsiveAttribute;
